import { CampaignRanking } from '@/domain/types/campaigns';

const getFirstMs = (r: CampaignRanking): number =>
  r.firstMentionAt?.toMillis() ?? r.lastMentionAt?.toMillis() ?? 0;

export function filterAndSortRanking(
  entries: CampaignRanking[],
  disabledUserIds: Set<string>,
): CampaignRanking[] {
  return entries
    .filter((r) => !disabledUserIds.has(r.userId))
    .sort((a, b) => {
      if (b.mentionCount !== a.mentionCount) return b.mentionCount - a.mentionCount;
      const tsDiff = getFirstMs(a) - getFirstMs(b);
      if (tsDiff !== 0) return tsDiff;
      return a.userId.localeCompare(b.userId);
    });
}
